var close = document.getElementsByClassName('close-all-destinations');
var overLay = document.getElementsByClassName('view-destinations-overlay');

$('.view-all-destinations-cta').on('click', function (e) {
  event.preventDefault();
    $('.all-destinations-wrapper').addClass('opened');
    $('body').addClass('no-scroll');

    const offset = -150;
    const overview = document.getElementsByClassName('all-destinations');
    const final = overview[0].getBoundingClientRect().top + window.pageYOffset + offset;
    window.scrollTo({top: final});
    console.log(final);


    overLay[0].classList.add('open');
    close[0].classList.add('open');

})

$('.close-all-destinations').on('click', function() {
  console.log('clicked');
    if ($('.all-destinations-wrapper').hasClass('opened')) {
        $('.all-destinations-wrapper').removeClass('opened');
        close[0].classList.remove('open');
        overLay[0].classList.remove('open');
        $('body').removeClass('no-scroll');
    }
})

$('.view-destinations-overlay').on('click', function() {
  console.log('clicked');
    if ($('.all-destinations-wrapper').hasClass('opened')) {
        $('.all-destinations-wrapper').removeClass('opened');
        close[0].classList.remove('open');
        overLay[0].classList.remove('open');
        $('body').removeClass('no-scroll');
    }
})